import { RowBetween } from 'components/Layout/Row'
import styled from 'styled-components'
import { CardBody, Card, Heading, Text, TooltipText } from 'vvs-uikit'
import { AppBody } from 'components/App'

export const FixedHeightRow = styled(RowBetween)`
  height: 24px;
`

export const StyledHeading = styled(Heading)<{ weight?: number }>`
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ weight }) => weight ?? 'normal'};
`
export const StyledCard = styled(Card)`
  margin: 0 8px 32px;
  display: flex;
  flex-direction: column;
  position: relative;
  color: ${({ theme }) => theme.colors.text};

  ${({ theme }) => theme.mediaQueries.sm} {
    margin: 0 12px 32px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    width: 400px;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    width: 580px;
  }
`
export const Body = styled(CardBody)`
  background-color: ${({ theme }) => theme.colors.backgroundAlt3};
`

export const OuterBody = styled(AppBody)`
  max-width: unset;
  padding: 10px 0 0 0;
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
  border-radius: 18px;
`
export const StyledText = styled(Text)`
  color: ${({ theme }) => (theme.isDark ? theme.colors.text : theme.colors.textSubtle)};
`

export const StyledTooltipText = styled(TooltipText)`
  color: ${({ theme }) => (theme.isDark ? theme.colors.text : theme.colors.textSubtle)};
`

export const StyledCalculateCard = styled.div`
  margin: 0 8px 70px;
  padding: 22px 24px;
  display: flex;
  gap: 10px;
  position: relative;
  color: ${({ theme }) => theme.colors.text};
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
  justify-content: space-between;
  align-items: center;
  max-width: 345px;
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.sm} {
    margin: 0 12px 46px;
    max-width: 370px;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    width: 400px;
    max-width: none;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    flex-direction: row;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    width: 580px;
  }
`
